module.exports = __webpack_public_path__ + "img/ios.bcfcb8ba.svg";